import { render, staticRenderFns } from "./FileAttachment.vue?vue&type=template&id=aec1a6c2&scoped=true&"
import script from "./FileAttachment.vue?vue&type=script&lang=js&"
export * from "./FileAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec1a6c2",
  null
  
)

export default component.exports